import { DescriptionField, TitleField } from "./CustomFields";

const fields = {
  DescriptionField,
  TitleField,
};

export default fields;
